import axios from "axios";
import { apiVariable } from "./apiVariable";
import { OperationsPlannerSummaryDto } from "../interfaces/Operations/operationsPlannerSummary";

const endpoint = `${apiVariable}/getOperationsPlannerSummary`;

export const fetchOperationsPlannerSummary = async (
  token: string | null | undefined,
  date?: string
): Promise<OperationsPlannerSummaryDto> => {
  if (!token) {
    throw new Error("Missing authentication token");
  }

  const response = await axios.get<OperationsPlannerSummaryDto>(endpoint, {
    params: { date },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};
